import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TableFooter, Card } from "@mui/material";
import React, { Fragment, useContext } from "react";
import { BrandContext } from "../../../contexts/BrandContext";

export default function AdminFareBreakdown(props){

    const brandContext = useContext(BrandContext);
    const {
        textContent={},
        textContent:{
            fareTableClientBreakdown='',
            fareTableColHeaderCo2Saving='',
            fareTableColHeaderSaving='',
            fareTableColHeaderDisbursement='',
            fareTableColHeaderGross='',
            fareTableColHeaderVat='',
            fareTableColHeaderNet='',
            fareTableInternalBreakdown='',
            fareTableTotal='',
            fareTableProfitTotal='',
            fareTableOutlayTotal=''

        }
    } = brandContext;
    const {
        fareDetails:{
            fareStage:{
                name:fareStageName=''
            },
            internalFares:fareDetails=[],
            internalOutlayTotal:{
                net:outlayTotalNet=0,
                vat:outlayTotalVat=0,
                gross:outlayTotalGross=0,
                disbursement:outlayTotalDisbursement=0,
            },
            internalProfitTotal:{
                net:profitTotalNet=0,
                vat:profitTotalVat=0,
                gross:profitTotalGross=0,
                disbursement:profitTotalDisbursement=0,
            },
            internalTotal:{
                net:totalNet=0,
                vat:totalVat=0,
                gross:totalGross=0,
                disbursement:totalDisbursement=0,
            }
        },
        clientFareDetails:{
            clientFacingFares:passengerFares=[],
            hasSaving:hasPassengerSaving=false,
            clientFacingTotal:{
                net:passengerTotalNet,
                vat:passengerTotalVat,
                gross:passengerTotalGross,
                disbursement:passengerTotalDisbursement,
                saving:passengerTotalSaving,
                co2Saving:passengerTotalCo2Saving
            }
        }
    } = props;


    return (
        <Card variant="outlined" className="darkBox" sx={{marginLeft:'-10px', marginRight:'-10px'}}>
            <Typography variant="body1" className="bodyBold">
                {textContent[fareStageName]}
            </Typography>
            <TableContainer >
                <Table className="fareDetailsTable" size="small"> 
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={4} className="headerCell rowCellKey">
                                <Typography variant="body1" className="bodyBold">{fareTableInternalBreakdown}</Typography>
                            </TableCell>
                            <TableCell className="headerCell"/>
                        </TableRow>
                        <TableRow>
                            <TitleCell> </TitleCell>
                            <TitleCell>{fareTableColHeaderNet}</TitleCell>
                            <TitleCell>{fareTableColHeaderVat}</TitleCell>
                            <TitleCell>{fareTableColHeaderDisbursement}</TitleCell>
                            <TitleCell>{fareTableColHeaderGross}</TitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fareDetails.map((item,index)=>{
                            const {
                                fareKey:key='',
                                net,
                                vat,
                                gross,
                                student={}
                            } = item;

                            const disbursement = (vat > 0 ? 0 : net);

                            let studentInitials = '';
                            if(student){
                                if('firstName' in student){
                                    const firstCharacter = student.firstName.split('')[0];
                                    const secondCharacter = student.lastName.split('')[0];
                                    studentInitials = `${firstCharacter}${secondCharacter}`;
                                }
                            }

                            const rowProps = {
                                net,
                                vat,
                                gross,
                                disbursement,
                                rowTitle:`${textContent[`taxiFareAdmin_${key}`]} ${studentInitials && ` (${studentInitials})`}`
                            };

                            return (
                                <TableRow key={index}>
                                    <RowBlock {...rowProps}/>
                                </TableRow>
                            );
                        })}

                            <TableRow className="totalsRow">
                                <RowBlock 
                                    rowTitle={fareTableOutlayTotal}
                                    net={outlayTotalNet}
                                    vat={outlayTotalVat}
                                    gross={outlayTotalGross}
                                    disbursement={outlayTotalDisbursement}
                                />
                            </TableRow>
                            <TableRow className="profitRow">
                                <RowBlock 
                                    rowTitle={fareTableProfitTotal}
                                    net={profitTotalNet}
                                    vat={profitTotalVat}
                                    gross={profitTotalGross}
                                    disbursement={profitTotalDisbursement}
                                />
                            </TableRow>
                            <TableRow className="totalsRow">
                                <RowBlock 
                                    rowTitle={fareTableTotal}
                                    net={totalNet}
                                    vat={totalVat}
                                    gross={totalGross}
                                    disbursement={totalDisbursement}
                                />
                            </TableRow>

                    </TableBody>
                    <TableRow><TableCell sx={{paddingTop:'20px'}}/></TableRow>
                    <TableHead>
                        <TableRow >
                            <TableCell className="headerCell rowCellKey" colSpan={4}>
                                <Typography variant="body1" className="bodyBold">{fareTableClientBreakdown}</Typography>
                            </TableCell>
                            <TableCell className="headerCell"/>
                        </TableRow>
                        <TableRow>
                            <TitleCell> </TitleCell>
                            <TitleCell>{fareTableColHeaderNet}</TitleCell>
                            <TitleCell>{fareTableColHeaderVat}</TitleCell>
                            <TitleCell>{fareTableColHeaderDisbursement}</TitleCell>
                            <TitleCell>{fareTableColHeaderGross}</TitleCell>
                            {hasPassengerSaving &&
                            <>
                                <TitleCell>{fareTableColHeaderSaving}</TitleCell>
                                <TitleCell>{fareTableColHeaderCo2Saving}</TitleCell>
                            </>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {passengerFares.map((studentMap,index)=>{
                            const {
                                fares={},
                                passenger:{
                                    firstName='',
                                    lastName=''
                                }
                            } = studentMap;


                            const keys = Object.keys(fares);
                            const values = Object.values(fares);


                            return (
                                <Fragment key={index}>
                                    {values.map((item,j)=>{
                                        const {
                                            net,
                                            vat,
                                            gross,
                                            disbursement,
                                            saving,
                                            co2Saving,
                                            fareKey:key
                                        } = item;
                                        

                                        const rowProps = {
                                            net,
                                            vat,
                                            gross,
                                            disbursement,
                                            rowTitle:`${firstName} ${lastName} ${textContent[`taxiFareCustomer_${key}`]}`
                                        };
                                        if(hasPassengerSaving){
                                            rowProps.saving = saving;
                                            rowProps.co2Saving = co2Saving; 
                                        }
                                        

                                        return (
                                            <TableRow key={index}>
                                                <RowBlock {...rowProps}/>
                                            </TableRow>
                                        );
                                    })}
                                </Fragment>
                            );

                        })}
                        <TableRow className="totalsRow">
                            <RowBlock
                                rowTitle="Total"
                                net={passengerTotalNet}
                                vat={passengerTotalVat}
                                gross={passengerTotalGross}
                                disbursement={passengerTotalDisbursement}
                                saving={hasPassengerSaving ? passengerTotalSaving : null}
                                co2Saving={hasPassengerSaving ? passengerTotalCo2Saving : null}
                            />
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
}


const fNum = (stringNumber) => parseFloat(stringNumber).toFixed(2);

const FareCell = (props) => {
    const {
        className=''
    } = props;
    return (
        <TableCell className={`rowCell ${className}`} ><Typography>{fNum(props.children)}</Typography></TableCell>
    );
};

const TitleCell = (props) => (<TableCell className="headerCell"><Typography >{props.children}</Typography></TableCell>);

const RowBlock = (props) => {
    const {
        rowTitle='',
        net='',
        vat='',
        gross='',
        disbursement='',
        saving=null,
        co2Saving=null
    } = props;
    
    return (
    <>
        <TableCell className="rowCellKey"><Typography>{rowTitle}</Typography></TableCell>
        <FareCell>{net}</FareCell>
        <FareCell>{vat}</FareCell>
        <FareCell>{disbursement}</FareCell>
        <FareCell>{gross}</FareCell>
        {saving !== null &&
            <FareCell className="boldCell">{saving}</FareCell>
        }
        {co2Saving !== null &&
            <FareCell>{co2Saving}</FareCell>
        }
    </>
    );
}